import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { JsonPipe } from '@angular/common';

@Component({
    templateUrl: './restricted-access.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './restricted-access.component.scss',
})

export class RestrictedAccessComponent implements OnInit {
    error: HttpErrorResponse;

    ngOnInit(): void {
        this.error = history.state.error;
    }
}
